<template>
  <div class="relative">
    <div class="d-flex justify-center text-center">
      <main-title align="center">
        <span v-t="`Pricing`" />
      </main-title>
    </div>
    <v-container>
      <div class="text-center">
        <div class="mx-auto mb-3" style="max-width: 240px">
          <v-select
            outlined
            rounded
            :items="intervals"
            :label="$t('Billing cycle')"
            dense
            v-model="interval"
            hide-details
          ></v-select>
        </div>
        <base-btn
          :text="full"
          :color="!full ? 'primary' : null"
          class="mx-1 mb-4"
          small
          @click="full = false"
        >
          <span v-t="'Show only differences'" />
        </base-btn>
        <base-btn
          :text="!full"
          :color="full ? 'primary' : null"
          class="mx-1 mb-4"
          small
          @click="full = true"
        >
          <span v-t="'Show comparison'" />
        </base-btn>
      </div>
      <PricingPlanItems
        is-landing-page
        v-if="plans"
        :items="plans"
        :interval="interval"
        :full="full"
      >
        <template #button-area>
          <div>
            <v-btn :to="{ name: 'register' }" color="secondary" large>
              <span v-t="'Get Started'" />
            </v-btn>
          </div>
        </template>
      </PricingPlanItems>
      <v-row class="justify-center">
        <div v-if="$store.state.subscriptionNotes">
          <span
            class="text-muted text-subtitle-2"
            v-for="(note, i) in $store.state.subscriptionNotes"
            :key="`note${i}`"
          >
            {{ note }}
          </span>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PricingPlanItems from "@/admin/blocks/subscription/components/PricingPlans/PricingPlanItems.vue";

export default {
  components: { PricingPlanItems },
  data() {
    return {
      intervals: [
        { text: this.$t("Monthly"), value: "month" },
        { text: this.$t("Yearly"), value: "year" },
      ],
      interval: "year",
      full: false,
    };
  },
  computed: {
    plans() {
      const plans = this.$store.state.plans;
      if (!plans) return null;
      return plans.filter((plan) => plan.interval === this.interval);
    },
  },
};
</script>
